<script type="text/ecmascript-6">
    import DesignerQuestionCollectionOption from "./DesignerQuestionCollectionOption.vue";
    import { nextTick } from "vue";

    export default {
        emits: ['update-option-count'],
        mixins: [
            DesignerQuestionCollectionOption
        ],
        props: {
            hardwareCylinder: {
              required: true,
            },
        },
        computed: {
            url(){
                return '/api/options/' + this.fabricator + '/tedee-accessories?question=' + this.question + '&hardware_cylinder=' + this.hardwareCylinder;
            },
            cache_key(){
                return '_' + this.question + '_' + this.hardwareCylinder;
            },
        },
        watch: {
          'filtered_option_list': function (new_val, old_val) {
            nextTick(()=>{
              var options = $('#radio--' + this.component_id + ' input').not('.icheck').not('.skip_icheck');

              options.addClass('icheck').iCheck({
                checkboxClass: 'checkboxstyle',
                radioClass: 'radiostyle',
                selectClass: 'selectstyle'
              });

              $('.icheck').iCheck('update');

              options.on('ifChecked', (e) => {
                this.localTarget = parseInt(e.target.value);
              });

              this.$emit('update-option-count', this.filtered_option_list.length);
            });
          }
        }
    }
</script>
